export interface CardCost {
  dust: number;
}

export const CARD_COST = "cardCost";
